import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import http from "../../../helpers/http";
import httpos from "../../../helpers/httpos";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";
import { FETCH_WISHLIST_CONTENT_SUCCESS } from "../../../states/actions/actionTypes";
import Text from "../../common/Text";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { doObjToFormData } from "../../../helpers/helpers";
import {
  updateMEmberCredits,
  updateContactInfo,
} from "../../../states/actions/fetchSiteSettings";
import ContactInfoPopup from "./contact_info";
import DeletePropertyLabel from "../../common/delete-property-label";
import { useCommercialAccess, upgradeMessage, userIsRestrictedFromContactInformation } from "../../../hooks/useCommercialAccess";
import UpgradeOverlay from "../../common/UpgradeOverlay";
import { PinStatusBadge } from "../../common/PinStatusPicker";
import { propertyDetailsPath } from "../../../helpers/propertyDetailsLink";

export default function ResultPropertyBlk({
  val,
  handleHoverProperty,
  propertyLabelNames,
  i,
  handleToggleForLabel,
  handleCheckboxChange,handleLikeClick,exportedPropertyIds = []}) {
      const [isDeleting, setIsDeleting] = useState(false);

  const dispatch = useDispatch();
  const memData = useSelector((state) => state.fetchSiteSettings?.memData);
  const { isRestricted } = useCommercialAccess(val, memData);
  const isContactRestricted = userIsRestrictedFromContactInformation(memData);

  const favoriteContent = useSelector(
    (state) => state.resultView.favoriteContent
  );
  const [isTypeLoading, setIsTypeLoading] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(null);

  const handleRequestMailOrTel = (e, type) => {
    e.preventDefault();
    // Spends a credit — checked here as well as behind the overlay.
    // Both gates, not just the contact one: with contact access but no
    // commercial access the anchor stays focusable under UpgradeOverlay, so
    // Enter would otherwise still fire the request.
    if (isContactRestricted || isRestricted) {
      return;
    }
    setIsTypeLoading(true);
    httpos
      .post(
        `request-property-contact/${val?.encoded_property_id}`,
        doObjToFormData({ type: type })
      )
      .then(({ data }) => {
        setIsTypeLoading(false);
        if (data?.status === 1) {
          if (data?.cached_data !== 1) {
            dispatch(updateMEmberCredits(data?.total_available_credits));
          }
          setShowContactInfo({
            email: data?.email,
            phone: data?.phone,
          });
          const contact_info = {
            id: val?.id,
            email: data?.email,
            phone: data?.phone,
          };
          dispatch(updateContactInfo(contact_info));
        } else {
          toast.error(<Text string={data?.msg} />, TOAST_SETTINGS);
        }
      })
      .catch((error) => {
        setIsTypeLoading(false);
      });
  };
  useEffect(() => {
    if (val?.email?.length > 0 || val?.phone?.length > 0) {
      setShowContactInfo({ email: val?.email, phone: val?.phone });
    }
  }, [val]);

  const isExported = exportedPropertyIds.includes(val?.fips_apn);

  // console.log(val?.labels_arr);
  return (
    <>
      <div
        className="inner_properties"
        key={i + 234 + 12789100000000}
        onMouseEnter={() => handleHoverProperty(val.parcel_id)}
        // z-index:0 makes the card a stacking context, which `position:
        // relative` alone does NOT. Without it the commercial UpgradeOverlay
        // (z-index 10) and the Exported badge (z-index 1) escape into the root
        // context and paint over the open filter dropdown (.drop_cnt, z-index
        // 2). Safe to isolate: nothing in this card needs to paint above a
        // sibling card — the action icons sit inside the card bounds, and
        // react-tooltip ships no z-index, so an overflowing tooltip was already
        // painted under the next card in tree order.
        style={{ position: 'relative', zIndex: 0 }}
      >
        {isDeleting ? (
                  <div className="deleteLoading">
                    <div class="loadingio-spinner-eclipse-spin">
                    <div class="load-spinner">
                      <div></div>
                    </div>
                  </div>
                  </div>
               ) : (
                  ""
                )} 
        {isExported && (
          <span
            style={{
              position: "absolute",
              top: "23px",
              right: "140px",
              backgroundColor: "#f0ad4e",
              color: "#fff",
              fontSize: "12px",
              fontWeight: "bold",
              padding: "2px 8px",
              borderRadius: "4px",
              zIndex: 1,
            }}
          >
            Exported
          </span>
        )}
        <div className="dt_cnt">
          <div className="col">
            <div className="price_date">
              <div className="flex propBlkHeader">
                <div className="cta_search_checkboxes">
                  <input
                    type="checkbox"
                    name="owners[]"
                    aria-label={`Select ${val?.fips_apn || val?.parcel_id || val?.id || "property"}`}
                    checked={val?.checked}
                    onChange={(e) => handleCheckboxChange(e, i)}
                  />
                  <span className="checkbox"></span>
                </div>
                <h5>
                  <strong>${Number(val.price).toLocaleString()}</strong> |{" "}
                  {val.date}
                </h5>
              </div>
              <h3>
                <Link
                  to={propertyDetailsPath(val.id)}
                  // target="_blank"
                >
                  {val.title}
                </Link>{" "}
              </h3>
              <h5>
                <strong>Last Viewed: </strong>
                {val?.last_viewed_date}
              </h5>
              <div className="custom_span">
                <PinStatusBadge propertyId={val?.id} />
                {val?.labels_arr?.map((label_row, index) => {
                  return (
                    <span
                      style={{
                        backgroundColor: label_row?.label_color,
                        color: label_row?.is_dark ? "#fff" : "#000",
                      }}
                      key={index}
                      className="label_wrap"
                      id={"label_" + label_row?.label_id}
                    >
                      {label_row?.label_name}
                      <DeletePropertyLabel
                        label_id={label_row?.label_id}
                        property_id={val?.id}
                        setIsDeleting={setIsDeleting}
                      />
                    </span>
                  );
                })}
              </div>

              {/* {propertyLabelNames &&
                Object.keys(propertyLabelNames).map((labelKey, index) =>
                  labelKey === val?.id || labelKey === val?.parcel_id ? (
                    <span
                      key={index + 9870 + 12789100000000}
                      style={{
                        backgroundColor: propertyLabelNames[labelKey]
                          ?.label_color
                          ? propertyLabelNames[labelKey]?.label_color
                          : "black",
                        color: propertyLabelNames[labelKey]?.is_dark
                          ? "#fff"
                          : "#000",
                      }}
                      id={"label_" + propertyLabelNames[labelKey]?.label_id}
                      className="label_wrap"
                    >
                      {propertyLabelNames[labelKey]?.label_name}
                      <DeletePropertyLabel
                        label_id={propertyLabelNames[labelKey]?.label_id}
                        property_id={val?.id}
                        setIsDeleting={setIsDeleting}
                      />
                    </span>
                  ) : (
                    ""
                  )
                )} */}
                {propertyLabelNames &&
                    Object.keys(propertyLabelNames).map((labelKey) =>
                      (labelKey === val?.id || labelKey === val?.parcel_id) &&
                      Array.isArray(propertyLabelNames[labelKey]) ? (
                        propertyLabelNames[labelKey]
                          // Labels added this session; once the results reload they are in labels_arr too.
                          .filter((labelObj) => !val?.labels_arr?.some((row) => row?.label_id === labelObj.label_id))
                          .map((labelObj, index) => (
                          <span
                            key={labelObj.label_id || index}
                            style={{
                              backgroundColor: labelObj.label_color || "black",
                              color: labelObj.is_dark ? "#fff" : "#000",
                            }}
                            id={"label_" + labelObj.label_id}
                            className="label_wrap"
                          >
                            {labelObj.label_name}
                            <DeletePropertyLabel
                              label_id={labelObj.label_id}
                              property_id={val?.id}
                              setIsDeleting={setIsDeleting}
                            />
                          </span>
                        ))
                      ) : null
                    )}

              <p className="dim_text">{val.build}</p>
            </div>
          </div>
          <div className="col hide_cell_text_col">
            <h4>Owner</h4>
            <p className="dim_text">{val.owner}</p>
          </div>
        </div>
        <div className="dt_foot">
          <div className="col">
            <ul className="info">
              <li>
                <img src="/images/bed.svg" alt="4 Beds" />
                <span>{val.beds}</span>
              </li>
              <li>
                <img src="/images/bath.svg" alt="3 Bathrooms" />
                <span>{val.baths}</span>
              </li>
              <li>
                <img src="/images/dimension.svg" alt="8x10 m²" />
                <span>{Number(val.square).toLocaleString()}</span>
              </li>
            </ul>
          </div>
          <div className="col">
            <div className="show_cell_text_col">
              <h4>Owner</h4>
              <p className="dim_text">{val.owner}</p>
            </div>
               {isContactRestricted ? (
              // Owner contacts are not on this plan. The row keeps its shape
              // and shows a lock chip rather than a clickable "View Contact"
              // that would 403 and spend nothing but the customer's patience.
              <div
                className="contact_info relative"
                // Isolates the overlay to this cell — without it the lock chip
                // paints over the open filter dropdown. See UpgradeOverlay.
                style={{ zIndex: 0 }}
                data-testid="card-contact-locked"
              >
                <div className="dp">
                  <img src="/images/profile.svg" alt="" />
                </div>
                <div className="cnt">
                  <h5>
                    <div className="p_contact_wrap">&mdash;</div>
                  </h5>
                </div>
                <UpgradeOverlay
                  title="Owner Contact Information"
                  message={upgradeMessage(memData, "for owner contact details", "Owner contact information is not included on your plan.")}
                  variant="inline"
                  testId="card-contact-upgrade-overlay"
                />
              </div>
            ) : (
              <>
                 {(
                (
                  (Array.isArray(showContactInfo?.phone) &&
                    showContactInfo.phone.some(p => p?.number)) ||
                  (Array.isArray(showContactInfo?.email) &&
                    showContactInfo.email.length > 0)
                )
              ) ? (
                <>
                  <ul className="social property_blk_social">
                    {Array.isArray(showContactInfo?.email) && showContactInfo.email.length > 0 && (
                      <li>
                        <ContactInfoPopup
                          contact_arr={showContactInfo.email}
                          heading="Available Emails:"
                          is_icon={true}
                          type="email"
                        />
                      </li>
                    )}
                    {Array.isArray(showContactInfo?.phone) && showContactInfo.phone.some(p => p?.number) && (
                      <li>
                        <ContactInfoPopup
                          contact_arr={showContactInfo.phone}
                          heading="Available Phone numbers:"
                          is_icon={true}
                          type="phone"
                        />
                      </li>
                    )}
                  </ul>
                </>
              ) : (
                // Otherwise show "View Contact"
                <div className="contact_info relative">
                  <div className="dp">
                    <img src="/images/profile.svg" alt="" />
                  </div>
                  <div className="cnt">
                    <h5>
                      <a
                        href="#!"
                        onClick={(e) => handleRequestMailOrTel(e, "call")}
                        disabled={isTypeLoading}
                      >
                        <div className="p_contact_wrap">
                          {isTypeLoading ? "Please wait!" : "View Contact"}
                        </div>
                      </a>
                    </h5>
                  </div>
                  {isTypeLoading && (
                    <div className="loadingio-spinner-eclipse-spin">
                      <div className="load-spinner">
                        <div></div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              </>
            )}


          </div>
        </div>
        <div className="cta_opt_lbl">
          <ReactTooltip
            id="label-properties"
            place="bottom"
            content="Label Property"
          />
          <a
            href="javascript:void(0)"
            onClick={() => handleToggleForLabel(val.id)}
            data-tooltip-id="label-properties"
          >
            <img src="/images/ticket_star.svg" alt="" />
          </a>
          <ReactTooltip
            id="open-new-tab"
            place="bottom"
            content="View Property"
          />
          <Link
            to={propertyDetailsPath(val.id)}
            target="_blank"
            data-tooltip-id="open-new-tab"
          >
            <img src="/images/maximize.svg" alt="" />
          </Link>
          <ReactTooltip
            id="add-favorite"
            place="bottom"
            content="Add To Favorites"
          />
          <button
            type="button"
            onClick={(e) => handleLikeClick( val.id, dispatch)}
            className={val.is_wish == 1 ? "active" : ""}
            data-tooltip-id="add-favorite"
            id={`wish_${val.id}`}
          >
            <img src="/images/heart_ico.svg" alt="" />
          </button>
        </div>

        {isRestricted && (
          <UpgradeOverlay
            testId="commercial-upgrade-overlay"
            message={upgradeMessage(
              memData,
              "for access",
              "Commercial properties are not included on your plan."
            )}
          />
        )}
      </div>
    </>
  );
}
